import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import PropTypes from 'prop-types';

const CurrencySelectListItem = ({ onClick, currency, selected }) => {
  let countriesString = '';
  if (currency.value === 'EUR') {
    countriesString = 'EUR | Eurozone';
  } else if (currency.countries) {
    countriesString = `${currency.value} | ${currency.countries}`;
  }

  return (
    <ListItem
      button
      divider
      onClick={onClick}
      key={currency.id}
      style={selected ? { borderBottom: '2px solid #6c3', height: '100%', paddingTop: '0.2rem', paddingBottom: '0.2rem' } : { height: '100%', paddingTop: '0.2rem', paddingBottom: '0.2rem' }}
    >
      <ListItemIcon style={{ width: '50px' }}>
        <div>
          {currency.flag ? (
            <img src={`/flags/${currency.flag}.svg`} style={{ maxWidth: '50px', maxHeight: '50px' }} alt="" />
        ) : ('')}
        </div>
      </ListItemIcon>
      <ListItemText primary={currency.label} secondary={countriesString} />
    </ListItem>
  );
};

export default CurrencySelectListItem;

CurrencySelectListItem.propTypes = {
  currency: PropTypes.instanceOf(Object).isRequired,
  selected: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

CurrencySelectListItem.defaultProps = {
  selected: false,
};



// WEBPACK FOOTER //
// ./src/components/calculator/currency-select/CurrencySelectListItem.js